import axios from 'axios'

import { getToken } from './auth'

const baseURL = process.env.REACT_APP_API || "http://localhost:3000"
const api = axios.create({ baseURL })


api.interceptors.request.use(async config => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // config.headers.Authorization = `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI1ZDM5YTU0NWNiNzE5MDEzNzQzMWUxNjQiLCJpYXQiOjE1NjQwNTg5NDl9.eWc5Fjhm4KhWHSneOoQSfJL4k74jKbhj5GywNnN2p5E`;
  
  return config;
});

export default api;